// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {getPlace} from './getPlace'
import {getPlaceList} from './getPlaceList'
import {getPlaceDetailList} from './getPlaceDetailList'
import {getPagination} from './getPagination'
import {getNextPage} from './getNextPage'
import {getPrevPage} from './getPrevPage'
import {getPlaceCount} from './getPlaceCount'

export const placeSelectors = {
  getPlace,
  getPlaceList,
  getPlaceDetailList,
  getPagination,
  getNextPage,
  getPrevPage,
  getPlaceCount,
}
